import styled from 'styled-components'
import { BLACK, GRAYSCALE_100, WHITE, GRAYSCALE_400 } from '@styles/colors'
import { INTER } from '@styles/fonts'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${GRAYSCALE_100};
`

export const SettingItem = styled.div`
  padding: 16px;
  background-color: ${WHITE};
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const SettingLabel = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${BLACK};
`

export const SettingContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SettingDescription = styled.span`
  color: ${GRAYSCALE_400};
  font-family: ${INTER.regular};
  font-size: 13px;
`
